export const LANGUAGE_FIELDS = {
  cultures: {
    fields: {
      fr: 'french_name',
      en: 'english_name',
      lat: 'latin_name',
    },
    labels: {
      fr: 'Français',
      en: 'English',
      lat: 'Latin',
    },
    defaultLanguage: 'fr',
  },
  enemies: {
    fields: {
      fr: 'french_name',
      en: 'english_name',
      lat: 'latin_name',
    },
    labels: {
      fr: 'Français',
      en: 'English',
      lat: 'Latin',
    },
    defaultLanguage: 'fr',
  },
};

export const AGRONOMIC_FILTER_CONFIGS = [
  {
    key: 'enemies',
    labelKey: 'treatment-search|filters.enemies',
    field: 'treatment_enemies.enemy',
    value_field: 'id',
    label_field: 'french_name',
    languageConfig: LANGUAGE_FIELDS.enemies,
    aggregate: false,
  },
  {
    key: 'commercial_products',
    labelKey: 'treatment-search|filters.commercial_products',
    field: 'treatment_products.product',
    value_field: 'id',
    label_field: 'name',
    aggregate: true,
  },
  {
    key: 'active_substances',
    labelKey: 'treatment-search|filters.active_substances',
    field: 'treatment_products.product.active_substances',
    value_field: 'id',
    label_field: 'name',
    aggregate: true,
  },
  {
    key: 'pesticide_groups',
    labelKey: 'treatment-search|filters.pesticide_groups',
    field:
      'treatment_products.product.active_substances.pesticide_group_associations.pesticide_group',
    value_field: 'id',
    label_field: 'name',
    aggregate: true,
  },
  {
    key: 'intervention_periods',
    labelKey: 'treatment-search|filters.intervention_periods',
    field: 'intervention_period',
    value_field: 'id',
    label_field: 'name',
    aggregate: true,
  },
  {
    key: 'culture_stages',
    labelKey: 'treatment-search|filters.culture_stages',
    field: 'culture_stage',
    value_field: 'id',
    label_field: 'name',
    aggregate: true,
  },
  {
    key: 'organic_approval',
    labelKey: 'treatment-search|filters.organic_approval',
    field: 'treatment_products.product.is_organic_approval',
    type: 'boolean_select',
    options: [
      { value: true, label: 'treatment-search|filters.organic_approved' },
      { value: false, label: 'treatment-search|filters.not_organic_approved' },
    ],
  },
  {
    key: 'soil_types',
    labelKey: 'treatment-search|filters.soil_types',
    field: 'soil_type',
    value_field: 'id',
    label_field: 'name',
    aggregate: true,
  },
  {
    key: 'intercrop_cultures',
    labelKey: 'treatment-search|filters.intercrop_cultures',
    field: 'treatment_intercroppings.intercrops',
    value_field: 'id',
    label_field: 'french_name',
    aggregate: true,
  },
];

export const HEALTH_FILTER_CONFIGS = [
  {
    key: 'acute_toxicity',
    labelKey: 'active-substance|filters.Acute toxicity',
    field: 'health.acute_toxicity_symbol_data.calculated_value',
    type: 'range_select',
  },
  {
    key: 'long_term_effects',
    labelKey: 'active-substance|filters.Long term effects',
    field: 'health.long_term_effect_symbol_data.calculated_value',
    type: 'range_select',
  },
];

export const ENVIRONMENT_FILTER_CONFIGS = [
  {
    key: 'fish_or_daphnia',
    labelKey: 'active-substance|filters.Fish or daphnia',
    field: 'environment.fishes_symbol_data.calculated_value',
    type: 'range_select',
  },
  {
    key: 'birds',
    labelKey: 'active-substance|filters.Birds',
    field: 'environment.birds_symbol_data.calculated_value',
    type: 'range_select',
  },
  {
    key: 'bees',
    labelKey: 'active-substance|filters.Bees',
    field: 'environment.bees_symbol_data.calculated_value',
    type: 'range_select',
  },
  {
    key: 'persistence',
    labelKey: 'active-substance|filters.Persistence',
    field: 'environment.persistence_symbol_data.calculated_value',
    type: 'range_select',
  },
  {
    key: 'leaching_potential',
    labelKey: 'active-substance|filters.Leaching potential',
    field: 'environment.leaching_symbol_data.calculated_value',
    type: 'range_select',
  },
];

export const WEED_GROUPS_FILTER_CONFIGS = [
  {
    key: 'annual_grasses',
    labelKey: 'treatment-search|filters.annual_grasses',
    field: 'weeds_group.enemies',
    weed_type: 'graminées_annuelles',
    column_display: true,
  },
  {
    key: 'annual_broadleaves',
    labelKey: 'treatment-search|filters.annual_broadleaves',
    field: 'weeds_group.enemies',
    weed_type: 'feuilles_larges_annuelles',
    column_display: true,
  },
  {
    key: 'perennial_grasses',
    labelKey: 'treatment-search|filters.perennial_grasses',
    field: 'weeds_group.enemies',
    weed_type: 'graminées_vivaces',
    column_display: true,
  },
  {
    key: 'perennial_broadleaves',
    labelKey: 'treatment-search|filters.perennial_broadleaves',
    field: 'weeds_group.enemies',
    weed_type: 'feuilles_larges_vivaces',
    column_display: true,
  },
  {
    key: 'other_weeds',
    labelKey: 'treatment-search|filters.other_weeds',
    field: 'weeds_group.enemies',
    weed_type: 'autres',
    column_display: true,
  },
];

export const EXTRA_FILTER_KEYS = [
  ...AGRONOMIC_FILTER_CONFIGS.map((c) => c.key),
  ...WEED_GROUPS_FILTER_CONFIGS.map((c) => c.key),
  ...HEALTH_FILTER_CONFIGS.map((c) => c.key),
  ...ENVIRONMENT_FILTER_CONFIGS.map((c) => c.key),
];

export const DOCUMENT_TYPE = 'TreatmentDocument';
